import React from "react";
import "./App.css"; // Import the CSS file for styling

function TaxationLaw(){

    return <div>

<img src="/TAXATION-LAW-.jpg" alt="Header" />
<h2>Taxation Law</h2>



    </div>;


}




export default TaxationLaw;
